import { usePollOptionsState } from "../PollOptionsState";
import { ChipButtonsListSection } from "./ChipButtonsList";
import { PollTypesEnum } from "../../../../../Shared/Types/Polls";

export function ResultVisibilityControlSection() {
    const { pollType, updatePollType } = usePollOptionsState();
    if (
        pollType !== PollTypesEnum.POLL_VISIBLE &&
        pollType !== PollTypesEnum.POLL_HIDDEN
    ) {
        return null;
    }

    return (
        <ChipButtonsListSection
            sectionTitle="Ergebnisse vor Abstimmung sichtbar?"
            items={[
                {
                    label: "ja",
                    isSelected: pollType === PollTypesEnum.POLL_VISIBLE,
                    onClick: () => updatePollType(PollTypesEnum.POLL_VISIBLE),
                },
                {
                    label: "nein",
                    isSelected: pollType === PollTypesEnum.POLL_HIDDEN,
                    onClick: () => updatePollType(PollTypesEnum.POLL_HIDDEN),
                },
            ]}
        />
    );
}
